import Module from './allLocations'
export default Module
